import { ArianeElement, ArianeStore, MomentService } from "@digicerba/common";
import { AsiFileService } from "@asi-ngtools/lib";
import {
  CreateRessourceMultimediaDto,
  FormationDto,
  IFormationWebServiceClient,
  SaveFormationDto
} from "@resources/resources";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ResourceMultimediaPipe } from "app/common/utils/image/resource.multimedia.pipe";


@Component({
  selector: 'enregistrement-formation-component',
  templateUrl: './enregistrement.formation.component.html',
  host: { 'class': 'page' }
})
export class EnregistrementFormationComponent {

  formationForm: FormGroup;
  formation: FormationDto;
  planSrc: String;
  programmeSrc: String;

  constructor(private arianeStore: ArianeStore, private resourcePipe: ResourceMultimediaPipe, private momentService: MomentService, private activatedRoute: ActivatedRoute, private router: Router, private fb: FormBuilder, private fileUtils: AsiFileService, private iFormationWebServiceClient: IFormationWebServiceClient) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Catalogue de formation",
        route: "/liste-formations"
      },
      {
        libelle: "Administration",
        route: "/administration"
      },
      {
        libelle: "Création formation",
        route: "/administration/enregistrement/formation"
      }
    ];

    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.formation = this.activatedRoute.snapshot.data['formation'];
    this.formationForm = this.createFormationForm(this.formation);
    if (this.formation) {
      if (this.formation.planId != null) {
        this.planSrc = this.resourcePipe.transform(this.formation.planId);
      }
      if (this.formation.programmeId != null) {
        this.programmeSrc = this.resourcePipe.transform(this.formation.programmeId);
      }
    }
  }

  private createFormationForm(formation: FormationDto): FormGroup {
    let formationForm = this.fb.group({
      reference: [formation != null ? formation.reference : null, Validators.required],
      titre: [formation != null ? formation.titre : null, Validators.required],
      dateFormation: [formation != null ? this.momentService.formatToLocalDate(formation.dateFormation) : null, Validators.required],
      duree: [formation != null ? formation.duree : null, Validators.required],
      order: [formation != null ? formation.order : null, Validators.required],
      lieux: [formation != null ? formation.lieux : null, Validators.required],
      programme: null, //formation != null ? this.formation.programmeId : null,
      plan: null, //formation != null ? this.formation.planId : null,
      tarif: [formation != null ? formation.tarif : null, Validators.required],
      active: [formation != null ? formation.active : false, Validators.required],
      nombrePlaces: [formation != null && formation.nombrePlaces ? this.formation.nombrePlaces : 17]
    });
    return formationForm;
  }

  goFormations() {
    this.router.navigate(['cerba/administration/formations']);
  }

  submit() {

    if (this.formationForm.valid) {
      let newFormation = new SaveFormationDto;
      newFormation.reference = this.formationForm.value.reference;
      newFormation.titre = this.formationForm.value.titre;
      newFormation.dateFormation = this.momentService.formatToLocalDate(this.formationForm.value.dateFormation);
      newFormation.duree = this.formationForm.value.duree;
      newFormation.order = this.formationForm.value.order;
      newFormation.lieux = this.formationForm.value.lieux;
      newFormation.tarif = this.formationForm.value.tarif;
      newFormation.active = this.formationForm.value.active;
      newFormation.nombrePlaces = this.formationForm.value.nombrePlaces ? this.formationForm.value.nombrePlaces : 17;


      let programme: CreateRessourceMultimediaDto;
      let fichier: File = this.formationForm.value.programme;
      let plan: CreateRessourceMultimediaDto;
      let fichier2: File = this.formationForm.value.plan;

      if (fichier == null && fichier2 == null) { // Aucun fichier uploaded
        this.createOrUpdateFormation(newFormation);
      } else if (fichier != null && fichier2 == null) { // seulement le programme est uploaded
        this.fileUtils.fileToBase64(fichier).subscribe(result => {
          newFormation.programme = this.createRessourceMultimedia(result, fichier);
          this.createOrUpdateFormation(newFormation);
        });
      } else if (fichier == null && fichier2 != null) {// seulement le plan est uploaded
        this.fileUtils.fileToBase64(fichier2).subscribe(result2 => {
          newFormation.plan = this.createRessourceMultimedia(result2, fichier2);
          this.createOrUpdateFormation(newFormation);
        });
      } else if (fichier != null && fichier2 != null) { // Les deux fichiers sont uploaded
        this.fileUtils.fileToBase64(fichier).subscribe(result => {
          newFormation.programme = this.createRessourceMultimedia(result, fichier);
          this.fileUtils.fileToBase64(fichier2).subscribe(result2 => {
            newFormation.plan = this.createRessourceMultimedia(result2, fichier2);
            this.createOrUpdateFormation(newFormation);
          });
        });
      }
    }
  }

  private createRessourceMultimedia(result: string, fichier: File): CreateRessourceMultimediaDto {
    let crm = new CreateRessourceMultimediaDto();
    result = result.substring(result.indexOf(",") + 1);
    crm.content = result;
    crm.name = fichier.name;
    crm.mimeType = fichier.type;
    crm.size = fichier.size;
    return crm;
  }

  private createOrUpdateFormation(newFormation: SaveFormationDto) {
    if (this.formation && this.formation.id) {
      newFormation.id = this.formation.id;
      console.log(newFormation)
      this.iFormationWebServiceClient.updateFormation(this.formation.id, newFormation).subscribe(() => {
        this.router.navigate(['cerba/administration/formations']);

      });
      return;
    } else {
      this.iFormationWebServiceClient.createFormation(newFormation).subscribe(() => {
        this.router.navigate(['cerba/administration/formations']);
      });
      return;
    }
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/administration/formation/enregistrement/enregistrement.formation.component.ts